import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer";
import AdminSales from "./AllOrders";

const OrderPage = () => {
  return (
    <NavigationDrawer>
      <AdminSales />
    </NavigationDrawer>
  );
};

export default OrderPage;
